module.exports = __webpack_public_path__ + "img/img_futa_thunderstitch.c906bfb2.png";